<div class="reset-page-wrap height-100">
  <div class="session-form-hold">
    <div class="text-center pt-8 pb-16">
      <img
        src="assets/images/MT18815.gif"
        alt="QTAC Choose the Future"
        class="mb-05"
      />
      <p class="heading-text">
        Please enter your new password.
      </p>
      <p class="body-text">
        Password must be at least six characters, contain one uppercase letter,
        one lowercase letter, one number and one special character.
      </p>
    </div>
    <div
      class="mb-1 qtac-error-div"
      data-test="error-message-register-main"
      *ngIf="showResetInvalid"
    >
      {{ resetErrorMessage }}
    </div>
    <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
      <div class="reset-input-container">
        <div>Email</div>
        <input
          data-test="input-email"
          class="qtac-input"
          matInput
          name="email"
          type="email"
          required
          formControlName="email"
          value=""
        />
        <ng-container *ngFor="let error of error_messages.email">
          <small
            data-test="error-email"
            *ngIf="
              formControls.email.hasError(error.type) &&
              formControls.email.touched
            "
            class="form-error-msg error-msg"
          >
            {{ error.message }}
          </small>
        </ng-container>
      </div>
      <div class="reset-input-container">
        <div>Confirmation Code</div>
        <input
          data-test="input-confirmation-code"
          class="qtac-input"
          matInput
          name="code"
          type="text"
          required
          formControlName="code"
          value=""
        />
        <ng-container *ngFor="let error of error_messages.code">
          <small
            data-test="error-code"
            *ngIf="
              formControls.code.hasError(error.type) &&
              formControls.code.touched
            "
            class="form-error-msg error-msg"
          >
            {{ error.message }}
          </small>
        </ng-container>
      </div>
      <div class="reset-input-container">
        <div>New Password</div>
        <input
          data-test="input-new-password"
          class="qtac-input"
          matInput
          name="password"
          type="password"
          required
          formControlName="password"
          value=""
        />
        <ng-container *ngFor="let error of error_messages.password">
          <small
            data-test="error-new-password"
            *ngIf="
              formControls.password.hasError(error.type) &&
              formControls.password.touched
            "
            class="form-error-msg error-msg"
          >
            {{ error.message }}
          </small>
        </ng-container>
      </div>
      <div class="reset-input-container">
        <div>Confirm Password</div>
        <input
          data-test="input-confirm-password"
          class="qtac-input"
          matInput
          name="confirm-password"
          type="password"
          required
          formControlName="confirmPassword"
          value=""
        />
        <ng-container *ngFor="let error of error_messages.confirmPassword">
          <small
            data-test="error-confirm-password"
            *ngIf="
              formControls.confirmPassword.hasError(error.type) &&
              formControls.confirmPassword.touched
            "
            class="form-error-msg error-msg"
          >
            {{ error.message }}
          </small>
        </ng-container>
      </div>
      <div class="text-center">
        <button
          data-test="reset-button"
          mat-raised-button
          class="reset-button mb-1"
          [disabled]="resetPasswordForm.invalid"
        >
          SET PASSWORD
        </button>
      </div>
    </form>
  </div>
</div>
